import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import PersistentControls from "@natklok/devTools/PersistentControls";
import PreReferredQuestionSlide from "@natklok/slides/PreReferredQuestionSlide";
import Loading from "../components/Loading";
import Multiplayer from "../containers/Multiplayer";
import MUIThemeWrapper from "./MUIThemeWrapper";
import ScrollToTop from "./ScrollToTop";
import { AlignCenter, HTMLRenderer } from "@natklok/components";
import { articlesObj } from "@common";
import { Typography } from "@mui/material";
import PreviewTest from "@natklok/features/Preview/PreviewTest";
import Translations from "@natklok/features/Translations";

const Header = lazy(() => import("../containers/Header"));
const Welcome = lazy(() => import("../containers/Welcome"));
const SeniorQuiz = lazy(() => import("../containers/SeniorQuiz"));
const ResultSlide = lazy(() => import("../slides/ResultSlide"));
const MinimizedResultSlide = lazy(() => import("../slides/MinimizedResultSlide"));
const MinimizedPreReferredQuestions = lazy(() => import("../slides/MinimizedPreReferredQuestions"));
const PageNotFound = lazy(() => import("../containers/PageNotFound"));
const ChooseGameModeSlide = lazy(() => import("../slides/ChooseGameModeSlide"));
const TestTakerSettingsSlide = lazy(() => import("../slides/TestTakerSettingsSlide"));
const PreReferredQuizSlide = lazy(() => import("../slides/PreReferredQuizSlide"));
const QuestionNotFound = lazy(() => import("../slides/QuestionNotFound"));
const QuestionsSlide = lazy(() => import("../slides/QuestionsSlide"));
const StyledConfettiAnimation = lazy(() => import("../components/StyledConfettiAnimation"));
const ThumbsDownAnimation = lazy(() => import("../components/ThumbsDownAnimation"));

const Boiler = () => {
  return (
    <MUIThemeWrapper>
      <ScrollToTop>
        <Suspense fallback={<Loading />}>
          {process.env.NODE_ENV === "development" && <PersistentControls />}

          <StyledConfettiAnimation />
          <ThumbsDownAnimation />

          <Header />
          <Routes>
            <Route path="/" element={<Welcome normal />} />
            <Route path="/multiplayer/*" element={<Multiplayer />} />

            <Route path="/test/senior" element={<SeniorQuiz />} />
            <Route
              path="/quiz/:quizmoduleid"
              element={<PreReferredQuizSlide isMinimized={false} />}
            />
            <Route path="/question/:questionid" element={<PreReferredQuestionSlide />} />

            <Route path="/questions" element={<QuestionsSlide />} />
            <Route path="/choose-gamemode" element={<ChooseGameModeSlide />} />
            <Route path="/settings" element={<TestTakerSettingsSlide />} />

            <Route
              path="/minimized-quiz/:quizmoduleid"
              element={<PreReferredQuizSlide isMinimized={true} />}
            />
            <Route path="/minimized-questions" element={<MinimizedPreReferredQuestions />} />
            <Route path="/minimized-results" element={<MinimizedResultSlide />} />

            <Route path="/results" element={<ResultSlide />} />
            <Route path="/question-not-found" element={<QuestionNotFound />} />
            <Route path="/iframe-test" element={<Test wide={false} />} />
            <Route path="/iframe-test-wide" element={<Test wide />} />
            <Route path="/preview/question" element={<PreviewTest />} />
            <Route
              path="/preview/question-feedback-correct"
              element={<PreviewTest isFeedback feedbackCorrectness="correct" />}
            />
            <Route
              path="/preview/question-feedback-incorrect"
              element={<PreviewTest isFeedback feedbackCorrectness="incorrect" />}
            />
            <Route path="/translations" element={<Translations />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </MUIThemeWrapper>
  );
};

const Test: React.FC<{ wide: boolean }> = ({ wide }) => {
  return (
    <AlignCenter style={{ width: wide ? "70%" : undefined }} withMaxWidth={!wide}>
      <div
        style={{
          width: "100%",
          background: "white",
          minHeight: "100vh",
          padding: 40,
          color: "black",
          fontSize: 12,
        }}
      >
        {articlesObj.map((articlesObj) => {
          return (
            <div style={{ marginTop: 80 }}>
              <Typography>
                <b>Passar för följande artiklar:</b>
                <br /> {articlesObj.articles}
                <br />
                <b>Iframe kod:</b>
                <br />
                <code style={{ borderRadius: 12 }}>{articlesObj.iframe}</code>
              </Typography>

              <HTMLRenderer>{articlesObj.iframe}</HTMLRenderer>
            </div>
          );
        })}
      </div>
    </AlignCenter>
  );
};

export default Boiler;
